var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 458,
    height: 458,
    viewBox: "0 0 458 458",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456.253 22.9689C462.371 9.51002 448.526 -4.33549 435.067 1.78217L235.656 92.4234C231.449 94.3356 226.621 94.3356 222.414 92.4234L23.0036 1.78216C9.54473 -4.3355 -4.30081 9.51001 1.81686 22.9689L92.4581 222.38C94.3703 226.586 94.3703 231.415 92.4581 235.621L1.81686 435.032C-4.30082 448.491 9.54471 462.336 23.0036 456.219L222.414 365.578C226.621 363.665 231.449 363.665 235.656 365.578L435.067 456.219C448.526 462.336 462.371 448.491 456.253 435.032L365.612 235.621C363.7 231.415 363.7 226.586 365.612 222.38L456.253 22.9689Z",
    fill: "#0B6F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.2634603014523a766ec33680498bfcf3.svg";
export { ForwardRef as ReactComponent };